import { BreakpointObserver } from '@angular/cdk/layout';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { registerIcons } from 'src/util/angular/ng-material-icon-helpers';
import { UserViewModel } from 'src/view-models/user-view-model';
import { MenuService, SideNavMenu } from './shared/menu.service';
import { CurrentUserService } from './core/current-user.service';

const icons = {
  assets: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'amgh-logo': '/dist/assets/images/amgh-logo.svg',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'gmr-logo': '/dist/assets/images/gmr-logo.svg',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'medi-heli': '/dist/assets/images/med-heli-noun_574818_cc.svg',
  },
};

@Component({
  selector: 'fl-app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  viewProviders: [MatExpansionPanel],
})
export class AppComponent implements OnInit, AfterViewInit {
  public user$: Observable<UserViewModel | undefined>;
  public menu$: Observable<SideNavMenu | undefined>;
  public menu: SideNavMenu;
  public sideNavMenu: SideNavMenu;

  // For debugging purposes - do not remove
  public clientInfo = {
    clientContext,
    buildEnvironment: environment,
  };

  constructor(
    public breakpointObserver: BreakpointObserver,
    iconRegistry: MatIconRegistry,
    domSanitizer: DomSanitizer,
    private changeDetectorRef: ChangeDetectorRef,
    user: CurrentUserService,
    private _menu: MenuService,
  ) {
    registerIcons(icons, iconRegistry, domSanitizer);
    this.user$ = user.valueChanges;
  }

  public ngOnInit() {
    this.user$.subscribe((u) => {
      this.menu = this._menu.sideNavMenu(u);
    });
  }

  public ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }
}
